import { render } from "./TheBreadcrumb.vue?vue&type=template&id=8f8771da"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__